import { useEffect } from 'react';

const clampInterval = (value, fallback) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric < 1000) {
    return fallback;
  }
  return Math.floor(numeric);
};

const buildJitteredMs = (intervalMs, jitterRatio) => {
  const safeJitter = Math.max(0, Math.min(0.4, Number(jitterRatio) || 0));
  if (!safeJitter) {
    return intervalMs;
  }

  const jitterRange = intervalMs * safeJitter;
  const offset = Math.random() * jitterRange * 2 - jitterRange;
  return Math.max(1000, Math.floor(intervalMs + offset));
};

export const useRuntimeAutoRefresh = ({
  enabled,
  intervalMs = 15000,
  pauseWhenHidden = true,
  jitterRatio = 0.15,
  onRefresh,
}) => {
  useEffect(() => {
    if (!enabled || typeof onRefresh !== 'function') {
      return undefined;
    }

    const safeInterval = clampInterval(intervalMs, 15000);
    let timeoutId;

    const tick = async () => {
      const hidden = typeof document !== 'undefined' && document.visibilityState === 'hidden';
      if (!(pauseWhenHidden && hidden)) {
        await onRefresh();
      }

      timeoutId = window.setTimeout(tick, buildJitteredMs(safeInterval, jitterRatio));
    };

    timeoutId = window.setTimeout(tick, buildJitteredMs(safeInterval, jitterRatio));

    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [enabled, intervalMs, pauseWhenHidden, jitterRatio, onRefresh]);
};

export default useRuntimeAutoRefresh;